import { render, staticRenderFns } from "./PrebidPartners.vue?vue&type=template&id=18fd7134&"
import script from "./PrebidPartners.vue?vue&type=script&lang=js&"
export * from "./PrebidPartners.vue?vue&type=script&lang=js&"
import style0 from "./PrebidPartners.vue?vue&type=style&index=0&id=18fd7134&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports